import { createEnrichmentIsland } from '@/utils/islands';

let loadedPromise: Promise<void> | null = null;

function elementLoaded(): Promise<void> {
  if (loadedPromise === null) {
    loadedPromise = new Promise<void>((resolve) => {
      import('../../Search/index.search.lazy').then((module) => {
        module.initNavSearch();
        resolve();
      });
    });
  }

  return loadedPromise;
}

async function buttonClickHandler(ev: Event, btn: Element, container: Element) {
  ev.stopPropagation();
  await elementLoaded();
  const field = container?.querySelector('[app="nav-search-field"]');
  if(!field) {
    return;
  }

  const expanded = btn.getAttribute('aria-expanded') === 'true';
  field.classList.toggle('hidden', expanded);
  field.setAttribute('aria-hidden', String(expanded));
  btn.setAttribute('aria-expanded', String(!expanded));
}

function initSearchButton() {
  createEnrichmentIsland('.nav-search-container', container => {
    const btn = container?.querySelector('[search-btn]');
    if (btn) {
      btn.addEventListener('click', evt => buttonClickHandler(evt, btn, container));
    }
  });
}

export default initSearchButton;